import { Link } from 'react-router-dom'
import Clock from './Clock'
import Balloon from './Balloon'
import Icon from './Icon'
import { Cloud } from './Drawings'
import avatar from '../images/avatar-blue.webp'
import { UPWORK } from '../constants/site'

// The establishing panel: Nikita, the pitch in his own balloon, and the red action.
const Hero = () => (
  <section className='mx-auto max-w-page px-gutter pt-6 md:pt-8'>
    <div className='mb-4 flex flex-wrap items-end justify-between gap-x-8 gap-y-2 md:mb-5'>
      <h1 className='font-display uppercase text-display'>Nikita Yeldynov</h1>
      <p className='lettering pb-2 text-[1.25rem]'>Full-stack developer · Next.js, React, TypeScript</p>
    </div>

    <div className='panel overflow-hidden bg-sky'>
      <div
        aria-hidden='true'
        className='absolute inset-x-0 bottom-0 h-[22%] border-t-stroke border-line bg-sand'
      />
      <Cloud className='absolute right-[6%] top-[12%] hidden w-40 sm:block' />
      <Cloud className='absolute right-[24%] top-[6%] hidden w-24 lg:block' />

      <p className='caption relative inline-block max-w-[40ch]'>
        Kharkiv, Ukraine. Top Rated on{' '}
        <a href={UPWORK} target='_blank' rel='noreferrer' className='underline underline-offset-4'>
          Upwork<span className='sr-only'> (opens in a new tab)</span>
        </a>
        , 100% Job Success.
      </p>

      <div className='relative flex flex-col gap-10 px-5 pb-8 pt-8 md:grid md:grid-cols-[auto_minmax(0,46rem)] md:items-end md:gap-12 md:px-[5%] md:pb-[5%] md:pt-10'>
        <img
          src={avatar}
          alt='Nikita Yeldynov'
          width='400'
          height='400'
          className='order-2 size-32 border-stroke border-line bg-paper object-cover sm:size-40 md:order-none md:size-[clamp(13rem,19vw,17rem)]'
        />

        <div>
          <Balloon tail='auto'>
            <p className='font-letter text-balloon'>
              You bring the idea, I’ll handle the rest: design, build, launch, and clear updates along the way.
            </p>
          </Balloon>
          <div className='mt-6 hidden flex-wrap gap-3 md:flex'>
            <Link to='/#contact' className='btn-signal text-[1.25rem]'>
              Get in touch
            </Link>
            <Link to='/#work' className='btn text-[1.25rem]'>
              See the work <Icon name='down' />
            </Link>
          </div>
        </div>
      </div>

      <div className='relative flex flex-wrap gap-3 px-5 pb-6 md:hidden'>
        <Link to='/#contact' className='btn-signal'>
          Get in touch
        </Link>
        <Link to='/#work' className='btn'>
          See the work <Icon name='down' />
        </Link>
      </div>

      <p className='lettering relative border-t-stroke border-line bg-paper px-3 py-1.5 text-coal sm:absolute sm:bottom-0 sm:right-0 sm:border-l-stroke'>
        <Clock /> · Available for work
      </p>
    </div>
  </section>
)

export default Hero
